import type { FC } from "react";

import type { CheckoutOrderSummarySocialMedia } from "@jti/commerce/types";

import { SocialIcon } from "./SocialIcon";

import styles from "./SocialMedia.module.scss";

type SocialMediaProps = {
  socialMediaTitle?: string;
  socialMedia: CheckoutOrderSummarySocialMedia[];
};

export const SocialMedia: FC<SocialMediaProps> = ({ socialMedia, socialMediaTitle }) => {
  return (
    <div className={styles.container} data-testid="socialMedia">
      {socialMediaTitle && <h5 className={styles.title}>{socialMediaTitle}</h5>}
      <div className={styles.linksContainer}>
        {socialMedia.map((link) => (
          <SocialIcon link={link} key={link.uri} />
        ))}
      </div>
    </div>
  );
};
